export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5459.bf15746a.jpg";